import { Injectable } from '@angular/core';
import { ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { pytCustTblDefConfig } from '@core/custome-modal/pytCustTbl/pytCustTbl.helper';
import { config } from '@core/interfaces/api_baseurl';
import { BehaviorSubject, tap } from 'rxjs';
import { ApiAccessControlService } from '../../helper/api-access-control.service';
import { ToasterService } from '@core/services/toaster.service';
import { CredtionalModalComponent } from '@page/verify-otp/credtional-modal/credtional-modal.component';
import { MdlExitOptions } from '@page/bill-pay-services/bill-pay-services.component';
import { PytCustTblService } from '@core/custome-modal/pytCustTbl/pyt-cust-tbl.service';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';
import { Router } from '@angular/router';
import { ApiService } from '@core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  Api_Key_List = new BehaviorSubject<any>(null)
  constructor(
    private _ApiService: ApiService,
    private _ConfirmationModalService: ConfirmationModalService,
    private _ApiAccessControlService: ApiAccessControlService,
    private _ToasterService: ToasterService,
    private _PytCustTblService: PytCustTblService,
    private _ConnectBankService: ConnectBankService,
    private _Router: Router,
  ) { }

  fetchCredentialsList(fetch: boolean = false) {
    if (this.Api_Key_List.getValue() && !fetch) {
      return this.Api_Key_List.asObservable();
    }
    return this._ApiService.post(config.Api_Key.getList, this.setFormData()).pipe(tap((res: any) => {
      this.Api_Key_List.next(res);
    }));
  }

  setFormData() {
    const { serverSearchVal,
      itmeLengthStartFrom,
      totalItmePerPage,
      sortBy,
      sortDirection } = pytCustTblDefConfig;

    const reqBody = {
      search: serverSearchVal,
      start: itmeLengthStartFrom.toString(),
      length: totalItmePerPage.toString(),
      orderby: sortBy,
      order: sortDirection
    }
    return reqBody;
  }

  GenerateAPIKey(data?: any) {
    const body = {
      otp_type: "api_generated"
    }
    this._ApiAccessControlService.sendOtp(body).subscribe((res: any) => {
      if (res.code === 200) {
        this._ApiAccessControlService.OtpModal(data)
          .subscribe((events: any) => {

            switch (events.type) {
              case 'sendOtp':
                this._ApiAccessControlService.apiAccessVerifyOtp(events.data).subscribe((res: any) => {
                  if (res.code === 200) {
                    events.initRef.close();

                    this.createApiKey().subscribe((res: any) => {
                      if (res.code === 200) {
                        this.fetchCredentialsList(true).subscribe();
                        let secretKey = res.data;
                        let mapped = Object.keys(secretKey).map((key) => ({
                          type: key,
                          value: secretKey[key],
                        }));
                        this._ConfirmationModalService.init(CredtionalModalComponent, {
                          data: secretKey,

                        }).subscribe((events: any) => {

                          switch (events.type) {
                            case MdlExitOptions.BTN_Confirm:
                              this._PytCustTblService.exportFile(
                                'credentials.txt',
                                '.txt',
                                mapped
                              );

                              // _Router.navigateByUrl('/inventory-kit');
                              // this.tableOptions
                              break;
                            case MdlExitOptions.BTN_Close:
                              if (this._Router.url.includes('/dashboard')) {
                                this._ConnectBankService.getAllBankDetailsList().subscribe((res: any) => { });
                              }
                              break
                            case MdlExitOptions.BTN_Cancel:
                              break;
                          }

                          events.initRef.close();
                        });
                      }

                    });
                    this._ToasterService.showSuccess(res.message, 'success');
                  } else {
                    this._ToasterService.showError(res.message, 'error');
                  }
                });
                break;
              case 'resendOtp':
                const body = {
                  otp_type: "otp_default"
                }
                this._ApiAccessControlService.sendOtp(body).subscribe();
                break;
              case 'closeTemplateModal':
                events.initRef.close();
                break;
            }
          })
      }
    });
  }



  createApiKey() {
    const reqBody = {
      expire_at: "never"
    }
    return this._ApiService.post(config.Api_Key.createApiKey, reqBody);
  }

  sendCredEmailVerifyOtp(formData: any) {
    return this._ApiService.post(config.Api_Key.sendCredEmail, formData);
  }

  deactiveKey(formData: any) {
    return this._ApiService.post(config.Api_Key.deactiveKey, formData);
  }

}
